import {useEffect, useRef, useCallback} from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import {BraintreeError, ensureErrorResponse} from "../utils";

export const useProcessFastlanePaymentToken = (
    {
        token,
        responseTypes,
        shouldSavePayment,
        onPaymentDataFilter
    }) => {

    const currentData = useRef({token});

    useEffect(() => {
        currentData.current = {token, responseTypes};
    }, [token, responseTypes]);

    useEffect(() => {
        const unsubscribe = onPaymentDataFilter(async (response, {nonceKey}) => {
            const {
                token,
                responseTypes
            } = currentData.current;
            try {
                return {
                    ...response,
                    meta: {
                        ...response.meta,
                        paymentMethodData: {
                            [nonceKey]: token.id,
                            braintree_cc_save_method: shouldSavePayment
                        }
                    }
                }
            } catch (error) {
                return ensureErrorResponse(responseTypes, error);
            }
        }, 5);
        return unsubscribe;
    }, [shouldSavePayment, onPaymentDataFilter]);

}